import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  TextInput, 
  PasswordInput, 
  Button, 
  Paper, 
  Title, 
  Container, 
  Text, 
  Stack 
} from '@mantine/core';
import { useAuth } from '../hooks/useAuth';

/**
 * Login page component
 */
const LoginPage = () => {
  // State for form fields
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState<string | null>(null);
  
  // Authentication hook
  const { login, isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  // Handle login form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validate form
    if (!username || !password) {
      setFormError('Username and password are required');
      return;
    }
    
    setFormError(null);
    
    // Call login function from auth context
    // Success/failure is handled in the login function itself
    await login(username, password);
  };

  return (
    <Container size="xs" className="flex items-center justify-center h-screen">
      <Paper radius="md" p="xl" withBorder className="w-full max-w-md">
        <Title order={2} className="text-center mb-6">Game Master Tool</Title>
        
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              required
              label="Username"
              placeholder="Your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              radius="md"
              autoComplete="username"
            />

            <PasswordInput
              required
              label="Password"
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              radius="md"
              autoComplete="current-password"
            />

            {formError && (
              <Text c="red" size="sm">
                {formError}
              </Text>
            )}

            <Button 
              type="submit" 
              radius="md" 
              fullWidth 
              loading={isLoading}
            >
              Login
            </Button>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
};

export default LoginPage; 